export default "__VITE_ASSET__CavXr070__"